export default "__VITE_ASSET__BLVPGWpg__"